// 官网提示说明（非表单）
export default {
  暂无相关的招标: '暂无相关的招标',
  发布于: '发布于',
  阅读: '阅读',
  发布日期: '发布日期',
  该招标已下架: '该招标已下架',
  该招标不存在: '该招标不存在',
}
